import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiMutation } from '../../../../common/model/api.mutation';

@Injectable({ providedIn: 'root' })
export class DeleteNotificationsApiMutation extends ApiMutation<
	string[],
	void
> {
	client = 'messaging';
	document = gql`
		mutation DeleteNotifications {
			deleteNotifications
		}
	`;
	method = 'deleteNotifications';
}
